import Button from '@hfe/max-button';
import LImage from '@max/leez-image';
import { createElement } from '@max/max';
export default function CloseBtn(props) {
    return <Button onPress={props.onClose} style={props.style}>
    <LImage source={{
        uri: 'https://p0.meituan.net/ingee/6577f5e2ca67b9eb3328e46e5561f19f1862.png'
    }} style={{
        width: '48rpx',
        height: '48rpx'
    }}/>
  </Button>;
}
